<template>
  <el-dialog
    title="测试详情"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="handleClose"
  >
    <div v-if="testData" class="test-detail">
      <!-- 基本信息 -->
      <el-descriptions :column="2" border>
        <el-descriptions-item label="测试名称">{{ testData.testName }}</el-descriptions-item>
        <el-descriptions-item label="测试类型">
          <el-tag :type="testTypeTag(testData.testType)" size="small">
            {{ testTypeText(testData.testType) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="测试时间">{{ testData.testDate }}</el-descriptions-item>
        <el-descriptions-item label="用时">{{ testData.duration }} 分钟</el-descriptions-item>
        <el-descriptions-item label="题目数量">{{ testData.totalQuestions }} 题</el-descriptions-item>
        <el-descriptions-item label="正确数量">
          <span class="success-text">{{ testData.correctCount }} 题</span>
        </el-descriptions-item>
        <el-descriptions-item label="得分">
          <span :class="scoreClass(testData.score)">{{ testData.score }}%</span>
        </el-descriptions-item>
        <el-descriptions-item label="通过状态">
          <el-tag :type="testData.score >= 60 ? 'success' : 'danger'" size="small">
            {{ testData.score >= 60 ? '通过' : '未通过' }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>

      <!-- 答题详情 -->
      <div class="answer-section">
        <h4>答题详情</h4>
        <div class="answer-placeholder">
          <el-empty description="答题详情加载中..." />
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TestDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    testData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    testTypeTag(type) {
      const tagMap = {
        daily: '',
        weekly: 'success',
        monthly: 'warning',
        final: 'danger',
      };
      return tagMap[type] || '';
    },
    testTypeText(type) {
      const textMap = {
        daily: '日常测试',
        weekly: '周测',
        monthly: '月测',
        final: '期末测试',
      };
      return textMap[type] || '未知';
    },
    scoreClass(score) {
      if (score >= 90) return 'excellent-score';
      if (score >= 80) return 'good-score';
      if (score >= 60) return 'pass-score';
      return 'fail-score';
    },
  },
};
</script>

<style scoped>
.test-detail {
  padding: 10px 0;
}

.answer-section {
  margin-top: 30px;
}

.answer-section h4 {
  margin-bottom: 15px;
  font-size: 16px;
  color: #303133;
}

.answer-placeholder {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-text {
  color: #67c23a;
  font-weight: 600;
}

.excellent-score {
  color: #67c23a;
  font-weight: 600;
  font-size: 18px;
}

.good-score {
  color: #409eff;
  font-weight: 600;
  font-size: 18px;
}

.pass-score {
  color: #e6a23c;
  font-weight: 600;
  font-size: 18px;
}

.fail-score {
  color: #f56c6c;
  font-weight: 600;
  font-size: 18px;
}

.dialog-footer {
  text-align: right;
}
</style>
